import React from 'react'
import logo from '../Assets/logo.png'

export default function ImagemEmpresa({ width }) 
{
    return(
        <div style={{ marginTop: "24px", marginBottom: "8px" }}>
            <img src={logo} style={{ width: width }}/>
        </div>
    )
}